import { Controller } from '@hotwired/stimulus'
import { Turbo } from '@hotwired/turbo-rails'

export default class extends Controller {
  applySort(event) {
    Turbo.visit(event.target.value)
  }
}
